
import { mapGetters } from 'vuex'
export default {
  props: {
    wording: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      vxCareInstructions: 'common/getCareInstructions',
    }),
    careInstructions() {
      const lang = this.$i18n.locale.split('-')[0].toLowerCase()
      const pci = this.product?.materials?.care_instructions || []
      return pci.reduce((acc, instruction) => {
        const text = this.vxCareInstructions?.[instruction]?.[lang]
        if (text) {
          acc.push({ key: instruction, text })
        }
        return acc
      }, [])
    },
  },
  methods: {
    parseFillPower(fill_power) {
      return Math.round(fill_power * 100) / 100
    },
  },
}
